import {
  CardBody,
  CardButtonWrapper,
  CardInformative,
  CardSupport,
  CustomDivider,
  ListItemModifier,
  TagLayout,
  TagWrapper
} from './style';
import { InformativeTag, Label, List, ListItem, MainButton } from '@icarros/ids-react';
import {
  formatFabricationAndModelYear,
  formatPriceToReal,
  removePlural
} from '../../../../utils/formatters';

import { CardOptions } from './CardOptions';
import { CardProps } from './constants';
import React from 'react';
import { getFirstImage } from '../../../../utils/getFirstImage';
import { useWebappFlags } from '../../../../hooks/useWebAppFlags';

export function Incomplete({ card }: CardProps): JSX.Element {
  const { getFlagOnSession } = useWebappFlags();

  return (
    <>
      <div>
        <img src={getFirstImage(card.fotos)} alt="Primeira imagem do anuncio" />
      </div>
      <CardBody>
        <CardSupport>
          <CardInformative>
            {card.filterText && (
              <InformativeTag variant="outlined" type="neutral">
                {removePlural(card.filterText)}
              </InformativeTag>
            )}
          </CardInformative>
          <CardOptions editId={card.id} showDelete showHelp />
        </CardSupport>

        <List>
          <ListItemModifier>
            <ListItem
              hasLine={false}
              label={`${card.veiculo.marca.nome} ${card.veiculo.modelo.nome}`}
              subLabel={`${card.veiculo.versao.nome} ${formatFabricationAndModelYear(
                card.veiculo.anoFabricacao,
                card.veiculo.anoModelo
              )}`}
              variant="simple"
            />
          </ListItemModifier>
        </List>
        <TagLayout>
          <Label size="medium" variant="neutral" weight="bold">
            {formatPriceToReal(card.valorVenda)}
          </Label>
          {card.chassiVerificado?.status && getFlagOnSession('validacaoChassi') && (
            <TagWrapper>
              <InformativeTag type="success" variant="outlined">
                Placa e chassi verificados
              </InformativeTag>
            </TagWrapper>
          )}
        </TagLayout>
        <CustomDivider variant="primary" />
        <CardButtonWrapper>
          <MainButton
            text="Continuar"
            iconName="itaufonts_seta_right"
            onClick={() => {
              const link = `${window.location.origin}${card.urlCompletarAnuncio}`;
              window.open(link);
            }}
          />
        </CardButtonWrapper>
      </CardBody>
    </>
  );
}
